import { render, staticRenderFns } from "./PriceRows.vue?vue&type=template&id=48eeed9c&scoped=true"
import script from "./PriceRows.vue?vue&type=script&lang=js"
export * from "./PriceRows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eeed9c",
  null
  
)

export default component.exports